import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  Long2qws0ah9gnpki as Long,
  Unit_instanceat14thlj150z as Unit_instance,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  protoOf180f3jzyo7rfj as protoOf,
  VOID7hggqo3abtya as VOID,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  suspendOrReturn49pspzlx5djv as suspendOrReturn,
  AutoCloseable1l5p57f9lp7kv as AutoCloseable,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  startCoroutineUninterceptedOrReturnGeneratorVersion1r5yf56916wr4 as startCoroutineUninterceptedOrReturnGeneratorVersion,
  Companion_instance144r68bk89en4 as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___init__impl__xyqfz8oelep8i0cbta as _Result___init__impl__xyqfz8,
  AbstractCoroutineContextElement2rpehg0hv5szw as AbstractCoroutineContextElement,
  Key_instance3trehy4y6zgij as Key_instance,
  getxe4seun860fg as get_0,
  minusKey2uxs00uz5ceqp as minusKey_0,
  releaseInterceptedContinuation17jnf0xkuoovi as releaseInterceptedContinuation,
  ContinuationInterceptor2624y0vaqwxwf as ContinuationInterceptor,
  Result__exceptionOrNull_impl_p6xea93g9kuxe56cw2k as Result__exceptionOrNull_impl_p6xea9,
  throwOnFailure24snjmtlqgzo8 as throwOnFailure,
  _Result___get_value__impl__bjfvqgbxrwpgk5sesh as _Result___get_value__impl__bjfvqg,
  printStackTrace18lnx7a39cni as printStackTrace,
  println2shhhgwwt4c61 as println,
  lazy2hsh8ze7j6ikd as lazy,
} from './kotlin-kotlin-stdlib.mjs';
import {
  atomic$boolean$1iggki4z65a2h as atomic$boolean$1,
  get_atomicfu$reentrantLock3o926yhldwf1 as get_atomicfu$reentrantLock,
  atomic$long$129k9zwo6n9ogd as atomic$long$1,
  atomic$int$11d5swdyn6j0pu as atomic$int$1,
} from './kotlinx-atomicfu.mjs';
import { FastArrayListw5fr1wlp4slq as FastArrayList } from './korlibs-datastructure-core-root-korlibs-datastructure-core.mjs';
import {
  invokeOnTimeout3llts2igdsa63 as invokeOnTimeout,
  Delay9umexudtwyie as Delay,
} from './kotlinx-coroutines-core.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class NonRecursiveLock {
  constructor() {
    this.i1v_1 = new Object();
  }
}
class BaseLockWithNotifyAndWait {}
function notify$default(unit, $super) {
  unit = unit === VOID ? Unit_instance : unit;
  var tmp;
  if ($super === VOID) {
    this.q1v(unit);
    tmp = Unit_instance;
  } else {
    var tmp_0 = $super.q1v;
    tmp = tmp_0.call(this, Unit_instance);
  }
  return tmp;
}
class LockImpl {
  constructor() {
    this.j1v_1 = atomic$boolean$1(false);
    var tmp = this;
    // Inline function 'kotlinx.atomicfu.locks.reentrantLock' call
    tmp.k1v_1 = get_atomicfu$reentrantLock();
    this.l1v_1 = atomic$long$1(new Long(0, 0));
    this.m1v_1 = atomic$int$1(0);
  }
  n1v() {
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.lock' call
    this.k1v_1;
    this.m1v_1.atomicfu$incrementAndGet();
    this.l1v_1.kotlinx$atomicfu$value = _NativeThread___get_id__impl__jog4wy(Companion_instance_0.o1v());
  }
  p1v() {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.m1v_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.unlock.<anonymous>' call
      var message = 'Must unlock inside a synchronization block';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'kotlinx.atomicfu.locks.ReentrantLock.unlock' call
    this.k1v_1;
    this.m1v_1.atomicfu$decrementAndGet();
  }
  q1v(unit) {
    if (!get_isSupported(Companion_instance_2))
      throw UnsupportedOperationException.d8();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.m1v_1.kotlinx$atomicfu$value > 0)) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.notify.<anonymous>' call
      var message = 'Must notify inside a synchronization block';
      throw IllegalStateException.z4(toString(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!this.l1v_1.kotlinx$atomicfu$value.equals(_NativeThread___get_id__impl__jog4wy(Companion_instance_0.o1v()))) {
      // Inline function 'korlibs.concurrent.lock.LockImpl.notify.<anonymous>' call
      var message_0 = 'Must lock the notify thread';
      throw IllegalStateException.z4(toString(message_0));
    }
    this.j1v_1.kotlinx$atomicfu$value = true;
  }
}
class Companion {
  s1v() {
    return get_NativeThreadThread_isSupported();
  }
  o1v() {
    return _NativeThread___init__impl__p2udts(NativeThreadThread_current());
  }
}
class Companion_0 {
  constructor() {
    Companion_instance_1 = this;
    this.t1v_1 = new PreferSyncIo(true);
    this.u1v_1 = new PreferSyncIo(false);
  }
  v1v(preferSyncIo) {
    return preferSyncIo === true ? this.t1v_1 : this.u1v_1;
  }
}
class PreferSyncIo {
  constructor(preferSyncIo) {
    Companion_getInstance_0();
    this.w1v_1 = preferSyncIo;
  }
  t1() {
    return Companion_getInstance_0();
  }
  toString() {
    return 'PreferSyncIo(preferSyncIo=' + this.w1v_1 + ')';
  }
  hashCode() {
    return getBooleanHashCode(this.w1v_1);
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PreferSyncIo))
      return false;
    var tmp0_other_with_cast = other instanceof PreferSyncIo ? other : THROW_CCE();
    if (!(this.w1v_1 === tmp0_other_with_cast.w1v_1))
      return false;
    return true;
  }
}
class BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = BaseSignal$_init_$lambda_tuu04y;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    this.c1w_1 = onRegister;
    this.d1w_1 = FastArrayList.sy();
    this.e1w_1 = FastArrayList.sy();
    this.f1w_1 = 0;
  }
  m1w() {
    return this.d1w_1.e1();
  }
  n1w() {
    return this.m1w() > 0;
  }
  g1w(once, handler) {
    this.c1w_1();
    var node = new Node(this, once, handler);
    this.d1w_1.h(node);
    return node;
  }
}
class Signal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = Signal$_init_$lambda_6vimhp;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  b1w(handler) {
    return this.g1w(false, handler);
  }
  h1w(handler) {
    return this.b1w(handler);
  }
  i1w(value) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
      if (this.d1w_1.g1()) {
        tmp$ret$0 = Unit_instance;
        break $l$block;
      }
      try {
        this.f1w_1 = this.f1w_1 + 1 | 0;
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_0 = this.d1w_1;
        var n = 0;
        var m = 0;
        while (n < this_0.e1()) {
          if (m >= 0 && !(m === n)) {
            this_0.o3(m, this_0.d1(n));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var node = this_0.d1(n);
          var remove = node.j1w_1;
          // Inline function 'korlibs.io.async.Signal.invoke.<anonymous>' call
          node.k1w_1(value);
          if (remove) {
            m = m - 1 | 0;
          }
          n = n + 1 | 0;
          m = m + 1 | 0;
        }
        while (this_0.e1() > m) {
          this_0.p3(this_0.e1() - 1 | 0);
        }
      }finally {
        this.f1w_1 = this.f1w_1 - 1 | 0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!this.e1w_1.g1()) {
          // Inline function 'korlibs.io.async.fastIterateRemove' call
          var this_1 = this.e1w_1;
          var n_0 = 0;
          var m_0 = 0;
          while (n_0 < this_1.e1()) {
            if (m_0 >= 0 && !(m_0 === n_0)) {
              this_1.o3(m_0, this_1.d1(n_0));
            }
            // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
            var it = this_1.d1(n_0);
            this.d1w_1.m3(it);
            if (true) {
              m_0 = m_0 - 1 | 0;
            }
            n_0 = n_0 + 1 | 0;
            m_0 = m_0 + 1 | 0;
          }
          while (this_1.e1() > m_0) {
            this_1.p3(this_1.e1() - 1 | 0);
          }
        }
      }
    }
    return tmp$ret$0;
  }
}
class AsyncSignal extends BaseSignal {
  constructor(onRegister) {
    var tmp;
    if (onRegister === VOID) {
      tmp = AsyncSignal$_init_$lambda_rsv6fb;
    } else {
      tmp = onRegister;
    }
    onRegister = tmp;
    super(onRegister);
  }
  s1w(handler) {
    return this.g1w(false, handler);
  }
  t1w(handler) {
    return this.s1w(handler);
  }
  u1w(value, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, value), $completion);
  }
}
class Node {
  constructor($outer, once, item) {
    this.l1w_1 = $outer;
    this.j1w_1 = once;
    this.k1w_1 = item;
  }
  f6() {
    if (this.l1w_1.f1w_1 > 0) {
      this.l1w_1.e1w_1.h(this);
    } else {
      this.l1w_1.d1w_1.m3(this);
    }
  }
}
class runBlockingNoSuspensions$1$context$1 extends AbstractCoroutineContextElement {
  static y1w($suspendCount, $box) {
    if ($box === VOID)
      $box = {};
    $box.x1w_1 = $suspendCount;
    var $this = this.in(Key_instance, $box);
    $this.w1w_1 = Key_instance;
    return $this;
  }
  t1() {
    return this.w1w_1;
  }
  fd(continuation) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.io.async.<no name provided>.interceptContinuation.<anonymous>' call
    var _unary__edvuaz = this.x1w_1._v;
    this.x1w_1._v = _unary__edvuaz + 1 | 0;
    return continuation;
  }
  b1c(timeMillis, continuation) {
    // Inline function 'kotlin.coroutines.resume' call
    // Inline function 'kotlin.Companion.success' call
    var tmp$ret$0 = _Result___init__impl__xyqfz8(Unit_instance);
    continuation.tc(tmp$ret$0);
    return Unit_instance;
  }
}
class runBlockingNoSuspensions$1 {
  constructor($suspendCount, $resultEx, $completed, $rresult) {
    this.a1x_1 = $resultEx;
    this.b1x_1 = $completed;
    this.c1x_1 = $rresult;
    var tmp = this;
    tmp.z1w_1 = runBlockingNoSuspensions$1$context$1.y1w($suspendCount);
  }
  rc() {
    return this.z1w_1;
  }
  d1x(result) {
    var exception = Result__exceptionOrNull_impl_p6xea9(result);
    if (!(exception == null)) {
      this.a1x_1._v = exception;
      this.b1x_1._v = true;
      printStackTrace(exception);
    } else {
      // Inline function 'kotlin.getOrThrow' call
      throwOnFailure(result);
      var tmp = _Result___get_value__impl__bjfvqg(result);
      var tmp0_elvis_lhs = (tmp == null ? true : !(tmp == null)) ? tmp : THROW_CCE();
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        _get_unitInstance__yoa8mq(this);
        var tmp_1 = Unit_instance;
        var tmp_2;
        if (!(Unit_instance == null)) {
          tmp_2 = Unit_instance;
        } else {
          tmp_2 = THROW_CCE();
        }
        tmp_0 = tmp_2;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var rvalue = tmp_0;
      this.c1x_1._v = rvalue;
      this.b1x_1._v = true;
    }
  }
  tc(result) {
    return this.d1x(result);
  }
}
class Companion_1 {}
class Lock extends LockImpl {}
//endregion
function get_isSupported(_this__u8e3s4) {
  return Companion_instance_0.s1v();
}
function _NativeThread___init__impl__p2udts(native) {
  return native;
}
function _NativeThread___get_native__impl__f44o82($this) {
  return $this;
}
function _NativeThread___get_id__impl__jog4wy($this) {
  return NativeNativeThread_getId(_NativeThread___get_native__impl__f44o82($this));
}
var Companion_instance_0;
function Companion_getInstance() {
  return Companion_instance_0;
}
var Companion_instance_1;
function Companion_getInstance_0() {
  if (Companion_instance_1 === VOID)
    new Companion_0();
  return Companion_instance_1;
}
function Signal$_init_$lambda_6vimhp() {
  return Unit_instance;
}
function invoke(_this__u8e3s4) {
  return _this__u8e3s4.i1w(Unit_instance);
}
function *_generator_invoke__zhh2q8($this, value, $completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks' call
    if ($this.d1w_1.g1()) {
      break $l$block;
    }
    try {
      $this.f1w_1 = $this.f1w_1 + 1 | 0;
      // Inline function 'korlibs.io.async.fastIterateRemove' call
      var this_0 = $this.d1w_1;
      var n = 0;
      var m = 0;
      while (n < this_0.e1()) {
        if (m >= 0 && !(m === n)) {
          this_0.o3(m, this_0.d1(n));
        }
        // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
        var node = this_0.d1(n);
        var remove = node.j1w_1;
        // Inline function 'korlibs.io.async.AsyncSignal.invoke.<anonymous>' call
        var tmp = node.k1w_1(value, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        if (remove) {
          m = m - 1 | 0;
        }
        n = n + 1 | 0;
        m = m + 1 | 0;
      }
      while (this_0.e1() > m) {
        this_0.p3(this_0.e1() - 1 | 0);
      }
    }finally {
      $this.f1w_1 = $this.f1w_1 - 1 | 0;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!$this.e1w_1.g1()) {
        // Inline function 'korlibs.io.async.fastIterateRemove' call
        var this_1 = $this.e1w_1;
        var n_0 = 0;
        var m_0 = 0;
        while (n_0 < this_1.e1()) {
          if (m_0 >= 0 && !(m_0 === n_0)) {
            this_1.o3(m_0, this_1.d1(n_0));
          }
          // Inline function 'korlibs.io.async.BaseSignal.iterateCallbacks.<anonymous>' call
          var it = this_1.d1(n_0);
          $this.d1w_1.m3(it);
          if (true) {
            m_0 = m_0 - 1 | 0;
          }
          n_0 = n_0 + 1 | 0;
          m_0 = m_0 + 1 | 0;
        }
        while (this_1.e1() > m_0) {
          this_1.p3(this_1.e1() - 1 | 0);
        }
      }
    }
  }
  return Unit_instance;
}
function AsyncSignal$_init_$lambda_rsv6fb() {
  return Unit_instance;
}
function BaseSignal$_init_$lambda_tuu04y() {
  return Unit_instance;
}
function runBlockingNoSuspensions(callback) {
  var completed = {_v: false};
  var rresult = {_v: null};
  var resultEx = {_v: null};
  var suspendCount = {_v: 0};
  startCoroutineUndispatched(callback, new runBlockingNoSuspensions$1(suspendCount, resultEx, completed, rresult));
  if (!completed._v)
    throw IllegalStateException.z4('runBlockingNoSuspensions was not completed synchronously! suspendCount=' + suspendCount._v);
  if (!(resultEx._v == null))
    throw ensureNotNull(resultEx._v);
  var tmp;
  if (rresult._v == null) {
    throwUninitializedPropertyAccessException('rresult');
  } else {
    tmp = rresult._v;
  }
  return tmp;
}
function startCoroutineUndispatched(_this__u8e3s4, completion) {
  $l$block: {
    // Inline function 'korlibs.io.async.startDirect' call
    var tmp;
    try {
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>' call
      // Inline function 'korlibs.io.async.withCoroutineContext' call
      completion.rc();
      // Inline function 'korlibs.io.async.startCoroutineUndispatched.<anonymous>.<anonymous>' call
      // Inline function 'kotlin.coroutines.intrinsics.startCoroutineUninterceptedOrReturn' call
      tmp = startCoroutineUninterceptedOrReturnGeneratorVersion(_this__u8e3s4, completion);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(e));
        completion.tc(tmp$ret$4);
        break $l$block;
      } else {
        throw $p;
      }
    }
    var value = tmp;
    if (!(value === get_COROUTINE_SUSPENDED())) {
      // Inline function 'kotlin.coroutines.resume' call
      // Inline function 'kotlin.Companion.success' call
      var value_0 = (value == null ? true : !(value == null)) ? value : THROW_CCE();
      var tmp$ret$7 = _Result___init__impl__xyqfz8(value_0);
      completion.tc(tmp$ret$7);
    }
  }
}
function _get_unitInstance__yoa8mq($this) {
  return Unit_instance;
}
var Companion_instance_2;
function Companion_getInstance_1() {
  return Companion_instance_2;
}
function get_NativeThreadThread_isSupported() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return NativeThreadThread_isSupported;
}
var NativeThreadThread_isSupported;
var warnSleep$delegate;
function NativeNativeThread_getId(thread) {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function NativeThreadThread_current() {
  _init_properties_NativeThread_js_kt__xin1zw();
  return new Long(0, 0);
}
function warnSleep$delegate$lambda() {
  _init_properties_NativeThread_js_kt__xin1zw();
  println('!!! Sync sleeping on JS');
  return Unit_instance;
}
var properties_initialized_NativeThread_js_kt_lgs6ti;
function _init_properties_NativeThread_js_kt__xin1zw() {
  if (!properties_initialized_NativeThread_js_kt_lgs6ti) {
    properties_initialized_NativeThread_js_kt_lgs6ti = true;
    NativeThreadThread_isSupported = false;
    warnSleep$delegate = lazy(warnSleep$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForClass(NonRecursiveLock, 'NonRecursiveLock', NonRecursiveLock);
initMetadataForInterface(BaseLockWithNotifyAndWait, 'BaseLockWithNotifyAndWait');
protoOf(LockImpl).r1v = notify$default;
initMetadataForClass(LockImpl, 'LockImpl', VOID, VOID, [BaseLockWithNotifyAndWait]);
initMetadataForCompanion(Companion);
initMetadataForCompanion(Companion_0);
protoOf(PreferSyncIo).ed = get;
protoOf(PreferSyncIo).cn = fold;
protoOf(PreferSyncIo).bn = minusKey;
protoOf(PreferSyncIo).dn = plus;
initMetadataForClass(PreferSyncIo, 'PreferSyncIo', VOID, VOID, [Element]);
initMetadataForClass(BaseSignal, 'BaseSignal', VOID, VOID, VOID, [0]);
initMetadataForClass(Signal, 'Signal', Signal, VOID, VOID, [0]);
initMetadataForClass(AsyncSignal, 'AsyncSignal', AsyncSignal, VOID, VOID, [1, 0]);
initMetadataForClass(Node, 'Node', VOID, VOID, [AutoCloseable]);
protoOf(runBlockingNoSuspensions$1$context$1).ed = get_0;
protoOf(runBlockingNoSuspensions$1$context$1).bn = minusKey_0;
protoOf(runBlockingNoSuspensions$1$context$1).gd = releaseInterceptedContinuation;
protoOf(runBlockingNoSuspensions$1$context$1).c1c = invokeOnTimeout;
initMetadataForClass(runBlockingNoSuspensions$1$context$1, VOID, VOID, VOID, [AbstractCoroutineContextElement, ContinuationInterceptor, Delay], [1]);
initMetadataForClass(runBlockingNoSuspensions$1);
initMetadataForCompanion(Companion_1);
initMetadataForClass(Lock, 'Lock', Lock, VOID, [LockImpl, BaseLockWithNotifyAndWait]);
//endregion
//region block: init
Companion_instance_0 = new Companion();
Companion_instance_2 = new Companion_1();
//endregion
//region block: exports
export {
  Companion_getInstance_0 as Companion_getInstancet6d3dkp9rzuf,
  Lock as Lock5n7hh3dgcidl,
  NonRecursiveLock as NonRecursiveLock2vf7fkhp857q,
  AsyncSignal as AsyncSignal3p186s2w7f15b,
  Signal as Signal3nnez3346azzf,
  invoke as invoke2sf88d1xeuyqh,
  runBlockingNoSuspensions as runBlockingNoSuspensions25hsuevf2mle,
};
//endregion
